import React from 'react';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import cn from 'classnames';
import Image from '@framework/router/Next/Image';

import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';
import LearnMore from '../LearnMore';
import Support from '@framework/ui/Pages/Landing/Sections/Support';
import Features from './Features';
import FooterPattern from '@framework/ui/Pages/Landing/Sections/FooterPattern';

import supportStamp from './assets/supportStamp.svg';
import introAnimation from '@/dataroom/ui/components/Landing/investorSet/Home/assets/introAnimation.webp';
import introPattern from '@/dataroom/ui/assets/introPattern.svg';
import supportPattern from './assets/supportPattern.svg';

import styles from '@/dataroom/ui/components/Landing/investorSet/Home/home.module.scss';
import baseStyles from '../tenantInvestorSet.module.scss';
import commonHomeStyles from '@/dataroom/ui/components/Landing/common/homeSection.module.scss';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import { buttonStyles } from '@dealroadshow/uikit-button';

const Home = () => (
  <div className={ styles.homeWrp }>
    <div className={ cn(commonHomeStyles.intro, styles.intro) }>
      <div className={ cn(commonHomeStyles.introPattern, styles.introPattern) }>
        <img src={ introPattern.src } />
      </div>
      <div className={ commonHomeStyles.introContainer }>
        <div className={ cn(commonHomeStyles.introContent, styles.introContent) }>
          <h1 className={ cn(commonHomeStyles.introTitle, baseStyles.title, styles.title) }>
            Access deal documents in minutes, not days
          </h1>
          <div className={ cn(commonHomeStyles.introDescription, baseStyles.description, styles.description) }>
            <p>
              InvestorSet is a document library for corporates to streamline investor access
              to deal documentation and periodic reporting. It’s secure, cost effective and
              backed by fanatical 24x7 support.
            </p>
            <p>InvestorSet is free for qualified investors.</p>
          </div>
          <NextNavLink
            to="/explore-sets"
            className={ cn(buttonStyles.action, styles.button) }
            dataTest="exploreSets"
          >
            Explore Sets
          </NextNavLink>
          <GetStartedButton
            className={ cn(buttonStyles.secondary, baseStyles.secondaryBtn, spacesStyles.mrn, styles.button) }
          />
        </div>
        <div className={ commonHomeStyles.introAnimation }>
          <div className={ cn(commonHomeStyles.introAnimationContainer, styles.introAnimationContainer) }>
            <div className={ styles.introAnimationShadow } />
            <Image
              src={ introAnimation.src }
              width={ 608 }
              height={ 460 }
              title={ 'Intro' }
              alt={ 'Intro' }
            />
          </div>
        </div>
      </div>
    </div>
    <Features />
    <div className={ styles.supportWrp }>
      <Support
        pattern={ supportPattern.src }
        patternClassName={ styles.supportPattern }
        headingClassName={ styles.supportHeading }
        titleClassName={ styles.supportTitle }
        descriptionClassName={ styles.supportDescription }
        title="Your experience means everything to us"
        description={ (
          <>
            We offer unlimited, 24x7x365 U.S. based phone, email and
            live chat support to you and any user in your deal.
          </>
        ) }
      />
      <div className={ styles.supportStamp }>
        <img src={ supportStamp.src } />
      </div>
    </div>
    <LearnMore />
    <FooterPattern />
  </div>
);

export default Home;
